import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { HOTEL } from "@/lib/site";

function formatErr(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (user) nav("/admin");
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-forest-deep flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <h1 className="font-serif text-4xl text-bone text-center">Regency Admin</h1>
        <p className="text-bone/60 text-center mt-2 text-sm">Blog & content management</p>
        <form onSubmit={submit} className="mt-10 bg-bone rounded-md p-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="text-xs uppercase tracking-widest text-stone">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              className="mt-2 w-full border border-stone/25 rounded px-4 py-3 bg-transparent focus:border-amber outline-none"
              required
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-stone">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="mt-2 w-full border border-stone/25 rounded px-4 py-3 bg-transparent focus:border-amber outline-none"
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full rounded-full bg-forest text-bone py-3.5 font-medium hover:bg-amber transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
